<template>
  <div class="back">
    <button type="button" @click="back">
      <inline-svg :src="require('@/assets/img/icon/arrow_back.svg')" />
    </button>
  </div>
</template>

<script>
import { getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import InlineSvg from "vue-inline-svg";

export default {
  name: "BackButton",
  components: {
    InlineSvg,
  },
  props: {
    backNumber: {
      type: Number,
      default: -1,
    },
    backPopup: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const router = useRouter();
    const { proxy } = getCurrentInstance();

    const back = () => {
      if (props.backPopup) {
        const popupInfo = {
          title: "뒤로가시겠습니까?",
          content: "뒤로가기시 예약데이터는 저장되지 않습니다.",
          leftBtnName: "아니오",
          rightBtnName: "네, 뒤로갈게요",
          onLeftBtn: () => {
            proxy.$root.$closePopup();
          },
          onRightBtn: () => {
            proxy.$root.$closePopup();
            router.push({ name: "Main" });
          },
        };
        proxy.$root.$openPopup(popupInfo);
      } else {
        router.go(props.backNumber);
      }
    };
    return { back };
  },
};
</script>
